<div (click)="close()">
    <app-workshop-widget [current_favor]="activePageService.currentFavor" [showBackButton]="false"></app-workshop-widget>
</div>
